import { Context } from '@leverege/plugin';
import { Toast } from '@leverege/ui-elements';
import { getInvoiceResource } from '../../util/Interface';
const downloadSpreadsheetAction = {
  id: 'billing.downloadSpreadsheet',
  name: 'Download Report Spreadsheet',
  layout: {
    sort: 'z.billing.2',
    sectionName: 'Billing Downloads'
  },
  matches: {
    use: ['contextMenu', 'mobileActionBar'],
    client: 'ItemInfoScreen',
    objectType: 'bill'
  },
  handles: checkForSpreadsheetAvailability,
  appearance: () => ({
    name: 'Download Report Spreadsheet'
  }),
  perform: async ({
    context
  }) => {
    callAPI(context, 'reportsSpreadsheet');
  }
};
async function callAPI(context, resourceName) {
  const systemId = context?.clientProps?.item?.systemId;
  const companyId = context?.clientProps?.item?.data?.company?.id;
  const locationId = context?.clientProps?.item?.data?.location?.id;
  const billingId = context?.clientProps?.item?.id;
  try {
    await getInvoiceResource(systemId, companyId, locationId, billingId, resourceName);
  } catch (err) {
    Toast.error('Error downloading report spreadsheet');
  }
}
function checkForSpreadsheetAvailability(context) {
  const bill = Context.getTargetOfType(context, 'bill');
  return bill?.data?.data?.reportsAvailable;
}
export default {
  install(molten) {
    molten.addPlugin('Action', downloadSpreadsheetAction);
  }
};